var map = {
	"./05b5d061dc11a48eff3aaea64c81c8c.jpg": 1200,
	"./dd53ccd0a513e43d4495d006e308456.jpg": 798,
	"./禹城润禹水务三水厂.jpg": 8699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6498;